import { createContext, type ReactNode, useContext } from "react";

/**
 * Words the components draw themselves, such as the screen reader label of a
 * dialog's X button. ui-web has no i18n: each app passes its translations
 * once, near the root, from the shared i18n (`common:close`). The English
 * defaults are only for a component rendered outside the provider.
 */
export type UiLabels = { close: string };

const UiLabelsContext = createContext<UiLabels>({ close: "Close" });

export function UiLabelsProvider({ labels, children }: { labels: UiLabels; children: ReactNode }) {
	return <UiLabelsContext value={labels}>{children}</UiLabelsContext>;
}

export function useUiLabels(): UiLabels {
	return useContext(UiLabelsContext);
}
